import { render, staticRenderFns } from "./AdminsMainPage.vue?vue&type=template&id=cb86e990&lang=pug"
var script = {}
import style0 from "./AdminsMainPage.vue?vue&type=style&index=0&id=cb86e990&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports